import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Avatar from '@atlaskit/avatar';

import { Icon } from 'src/components/sidebar/src/expander/styles';
import { WorkspaceBase } from 'src/sections/account/user-workspaces-resource';

import { messages } from './i18n';

type WorkspaceIconProps = {
  // `name` is optional because the new 2.0/user/workspaces endpoint does not return it.
  // Falls back to `slug` for alt text when absent.
  workspace?: WorkspaceBase & { name?: string };
  intl: IntlShape;
};

const WorkspaceIcon = ({ workspace, intl }: WorkspaceIconProps) => {
  const src = workspace ? workspace.links.avatar.href : undefined;

  const altText = workspace
    ? intl.formatMessage(messages.workspaceBreadcrumbsAvatarAltText, {
        workspaceName: workspace.name ?? workspace.slug,
      })
    : undefined;

  return (
    <Icon>
      <Avatar size="xsmall" appearance="square" src={src} name={altText} />
    </Icon>
  );
};

// eslint-disable-next-line import/no-default-export
export default injectIntl(WorkspaceIcon);
